import React, { useEffect, useState } from "react";
import "./styles.scss";

import logo from "../../assets/images/logo.png";
import { Link, useSearchParams } from "react-router-dom";
import NavigationBar from "./NavigationBar";
import ClockTime from "../ClockTime";
import UserBalance from "../UserBalance";
import { useTheme } from "../../hook/useThemes";
import logoNew from "../../assets/images/logo.png";
import { activeEventFathom } from "../../utils/utils";
import FunMode from "./FunMode";
import useDeviceDetect from "../../hook/useDeviceDetect";
type NavigationProps = {
  isHiddenMenu?: boolean;
};
function Navigation(props: NavigationProps) {
  const { isHiddenMenu = false } = props;
  const { settingImage } = useTheme();
  const [searchParams] = useSearchParams();
  const demo = searchParams.get("demo") === "true";
  const { isMobile } = useDeviceDetect();

  const [query, setQuery] = useState("");

  useEffect(() => {
    if (window) {
      setQuery(window.location.search || "");
    }
  }, [searchParams]);

  return (
    <div
      className="wrapper-navigation"
      style={{
        backgroundImage: `url(${
          isMobile ? settingImage.bg_header_mobile : settingImage.bg_header
        })`,
      }}
    >
      {!isHiddenMenu && (
        <div className="container navigation-content">
          <div className="wrapper-title">
            <UserBalance />
            <ClockTime />
            <div />
          </div>
          <Link
            to={`/${query}`}
            onClick={() => {
              activeEventFathom("Menu-Logo");
            }}
            className="wrap-logo"
          >
            <img className="img-logo" src={settingImage?.logo || logo} alt="" />

            {demo && <FunMode />}
          </Link>

          <NavigationBar />
        </div>
      )}

      {isHiddenMenu && (
        <div className="wrap-logo-isHiddenMenu">
          <Link to={`/${window.location.search}`}>
            <img className="img-logo" src={logoNew} alt="" />
          </Link>
        </div>
      )}

      <a
        className="hidden-link"
        href="https://bitbloxgames.com/casinobeats23/index_upordown.html"
        target="_parent"
        rel="noreferrer"
      >
        {" "}
      </a>
    </div>
  );
}

export default Navigation;
